<ng-container *ngIf="priceLoading; else showAddToCart">
  <eb-spinner [size]="1"></eb-spinner>
</ng-container>
<ng-template #showAddToCart>
  <ng-container *ngIf="_product">
    <eb-add-to-cart
      *ngIf="
        (hasValidPrice$ | async) &&
          hasOrderableProduct(_product) &&
          (userAuth.isUserLoggedIn() | async);
        else showRequestQuote
      "
      [product]="_product"
      [isAvailable]="isAvailable || _product.orderable"
      [hasSuccessor]="showSuccessor"
      [showQuantity]="showQuantity"
      [iconOnly]="iconOnly"
      [showCountOfProductInCart]="showCountOfProductInCart"
      [favoritesView]="favoritesView"
      [purchaseProduct]="true"
      [productPrice]="price"
    ></eb-add-to-cart>
  </ng-container>
</ng-template>

<ng-template #showRequestQuote>
  <a
    *ngIf="!showSuccessor || (!_product.isExpiring && !(hasValidPrice$ | async))"
    [ngbTooltip]="'productVariantList.requestQuote' | cxTranslate"
    [routerLink]="['/rfp']"
    [queryParams]="{ productCode: _product.code, productName: _product.name }"
    data-cy="rfp-link"
    [class.purchase-product__request-quote-btn]="!iconOnly"
    [class.purchase-product__rfp-link--iconOnly]="iconOnly"
    (click)="requestRfpEvent()"
  >
    {{ !iconOnly ? ('requestQuote.sendRequest' | cxTranslate) : '' }}
    <cx-icon [type]="IconType.FILE"></cx-icon>
  </a>
  <eb-info-box
    *ngIf="!iconOnly && !_product.orderable"
    text="requestQuote.text"
    icon="bell"
    infoType="WARN"
  ></eb-info-box>
</ng-template>
